module.exports = __webpack_public_path__ + "Roboto-Light.woff?c8405cfa0df9fb2e47ef1c516cef59a8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/Light/Roboto-Light.woff?v=2.137
// module id = 674
// module chunks = 7